import { RootState } from "../..";

export const projectSelector = (state: RootState) => state.project;
